module.exports = __webpack_public_path__ + "static/Montserrat-900-e3242149669bebf6afc4b0b5d22ec6ae.ttf";